import { getClasses } from '@/utils';

export type SortingIndicatorProps = {
  direction?: 'asc' | 'desc' | 'none' | '' | undefined | null | false;
} & React.HTMLAttributes<HTMLSpanElement>;

const SortingIndicator = ({ className, direction, ...props }: SortingIndicatorProps): JSX.Element => {
  const classes = getClasses('SortingIndicator', `SortingIndicator-${direction}`, className);
  const icon = getClasses(
    'fa',
    ['fa-sort', direction]
      .map((dir) => (dir === 'none' ? undefined : dir))
      .filter(Boolean)
      .join('-')
  );

  return (
    <span {...props} className={classes}>
      <i className={icon} />
    </span>
  );
};

export default SortingIndicator;
